<template>
  <div class="clubView">
    <article class="clubSignup">
      <section class="clubSignup__left">
        <div class="clubSignup__header">
          Вступление в Клуб Кибердеда: Ваш следующий шаг
          <div class="clubSignup__headerAccent"> в мире IT и OSINT</div>
        </div>
        <div class="clubSignup__join">
          <div class="clubSignup__joinText">
            Клуб «Кибердеда» — это больше, чем просто сообщество. Это точка притяжения для специалистов самых разных
            областей: от айтишников и аналитиков до исследователей OSINT и тех, кто ищет свою философию в цифровом мире.
            Мы объединяем людей, которым интересно не только обмениваться знаниями, но и формировать собственную
            культуру — братство тех, кто понимает ценность открытой информации, взаимопомощи и развития.
            {{JSON.stringify(userSettings)}}
          </div>
          <div class="clubSignup__joinButtons">
            <ActionButton
                v-if="!settings.user.is_at_club"
                style="background-color: #6FC062; color: #212226;"
                @buttonClick="$router.push({name: 'ClubSignUpView'})"
            >
              <template #caption>Подать заявку</template>
            </ActionButton>
<!--            <ActionButton style="">
              <template #caption>О клубе</template>
            </ActionButton>-->
          </div>

        </div>
      </section>
      <section class="clubSignup__right">
        <img :src="require('@/assets/img/club/main.png')" alt=""/>
      </section>
    </article>
    <article class="clubHistoryContainer">
      <ClubHistory></ClubHistory>
    </article>
    <article class="clubOptionsArticle">
      <ClubOptions></ClubOptions>
    </article>
    <article class="clubGalleryArticle">
      <ClubGallery></ClubGallery>
    </article>
    <article class="clubLives">
      <ClubLives></ClubLives>
    </article>
    <article class="clubPhilosophyArticle">
        <ClubPhilosophy></ClubPhilosophy>
    </article>
    <article class="clubFAQArticle">
      <ClubFAQ></ClubFAQ>
    </article>
  </div>
</template>

<script>
import ActionButton from "@/components/ui/ActionButton.vue";
import ClubHistory from "@/components/ClubView/ClubHistory.vue";
import ClubOptions from "@/components/ClubView/ClubOptions.vue";
import ClubGallery from "@/components/ClubView/ClubGallery.vue";
import ClubLives from "@/components/ClubView/ClubLives.vue";
import ClubPhilosophy from "@/components/ClubView/ClubPhilosophy.vue";
import ClubFAQ from "@/components/ClubView/ClubFAQ.vue";
import {useSettingsStore} from "@/store/settings";

export default {
  name: "ClubView",
  components: {
    ClubFAQ,
    ClubPhilosophy,
    ClubLives,
    ClubGallery,
    ClubOptions,
    ClubHistory,
    ActionButton
  },
  setup() {
    const settings = useSettingsStore();
    return {settings}
  }
}
</script>

<style scoped lang="scss">
.clubView {
  article {
    margin-bottom: 105px;
    @include respond-to('md') { margin-bottom: 60px; }
  }
}

.clubSignup {
  display: flex;
  gap: 20px;
  text-align: left;

  @include respond-to('md') { flex-direction: column; }

  &__header {
    font-family: var(--cd-bold-font);
    font-size: clamp(24px, 4vw, 36px);
  }

  &__headerAccent {
    color: var(--cd-green);
  }

  &__left {
    flex: 1 1 320px;
    border-radius: 20px;
    background: var(--cd-card-bg);
    padding: 34px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @include respond-to('sm') { padding: 20px; }

    button { width: 150px; }
  }

  &__joinText {
    font-size: 16px;
    font-weight: 500;
    font-family: var(--cd-default-font);
  }

  &__joinButtons {
    padding-top: 24px;
    display: flex;
    gap: 10px;
  }

  &__right {
    flex: 1 1 300px;

    img {
      width: 100%;
      height: auto;
      border-radius: var(--cd-card-border-radius);
      object-fit: cover;
    }
  }
}
</style>
